import type { ApiClient } from './client';

/** ANX-064 — богатый контекст визитёра для контекст-панели. */
export interface VisitorContext {
  visitor: {
    id: string;
    name?: string | null;
    email?: string | null;
    phone?: string | null;
  };
  lastUrl: string | null;
  referrer: string | null;
  userAgent: string | null;
  language: string | null;
  screen: string | null;
  geoCountry: string | null;
  geoCity: string | null;
  firstSeenAt: string;
  lastSeenAt: string;
  attributes: Record<string, unknown>;
  pastConversations: PastConversation[];
}

export interface PastConversation {
  id: string;
  status: 'open' | 'closed';
  createdAt: string;
  lastMessageAt: string;
  closedAt: string | null;
  csatScore?: 1 | -1;
}

interface Raw {
  visitor: { id: string; name?: string | null; email?: string | null; phone?: string | null };
  last_url: string | null;
  referrer: string | null;
  user_agent: string | null;
  language: string | null;
  screen: string | null;
  geo_country: string | null;
  geo_city: string | null;
  first_seen_at: string;
  last_seen_at: string;
  attributes: Record<string, unknown> | null;
  past_conversations: Array<{
    id: string;
    status: string;
    created_at: string;
    last_message_at: string;
    closed_at: string | null;
    csat_score?: number | null;
  }>;
}

export async function getVisitorContext(
  client: ApiClient,
  visitorId: string,
): Promise<VisitorContext> {
  const r = await client.request<Raw>(`/api/v1/visitors/${visitorId}/context`);
  return {
    visitor: r.visitor,
    lastUrl: r.last_url,
    referrer: r.referrer,
    userAgent: r.user_agent,
    language: r.language,
    screen: r.screen,
    geoCountry: r.geo_country,
    geoCity: r.geo_city,
    firstSeenAt: r.first_seen_at,
    lastSeenAt: r.last_seen_at,
    attributes: r.attributes ?? {},
    pastConversations: r.past_conversations.map((c) => ({
      id: c.id,
      status: c.status as PastConversation['status'],
      createdAt: c.created_at,
      lastMessageAt: c.last_message_at,
      closedAt: c.closed_at,
      ...(c.csat_score === 1 || c.csat_score === -1 ? { csatScore: c.csat_score } : {}),
    })),
  };
}
